import React from 'react';
import Clock from '../components/clock';
import '../styles/App.less';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Clock />
      </header>
    </div>
  );
}

export default App;
